import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-structure",
  "use": "icon-nav-structure-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-structure\">\r\n<path d=\"M95.5,144.8l-54.7-35c-2.8-1.8-6.3-1.8-9.1,0L3.2,127.9c-4.3,2.7-4.3,9,0,11.8l92.2,59c2.8,1.8,6.3,1.8,9.1,0l92.2-59\r\n\tc4.3-2.7,4.3-9.1,0-11.8l-28.4-18.1c-2.8-1.8-6.3-1.8-9.1,0l-54.7,35C101.8,146.6,98.2,146.6,95.5,144.8z\" />\r\n<path d=\"M95.5,1.3l-92.2,59c-4.3,2.7-4.3,9,0,11.8l92.2,59c2.8,1.8,6.3,1.8,9.1,0l92.2-59c4.3-2.7,4.3-9,0-11.8l-92.2-59\r\n\tC101.8-0.4,98.2-0.4,95.5,1.3z M71.3,60.3l24.2-15.4c2.8-1.8,6.3-1.8,9.1,0l24.2,15.4c4.3,2.7,4.3,9.1,0,11.8l-24.2,15.4\r\n\tc-2.8,1.8-6.3,1.8-9.1,0L71.3,72.1C67,69.3,67,63,71.3,60.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-structure.svg
// module id = ZFWB
// module chunks = 13